import i18n from './i18n'
class User {
  constructor(userInfo) {
    this.user = userInfo;
  }

  get email() {
    return this.user.email;
  }

  get uid() {
    return this.user.uid;
  }

  get affId() {
    return this.user.affId;
  }

  get userType() {
    if (this.user.planExpiredAt > Date.now()) {
      return this.user.planId;
    }
    return 'FREE';
  }

  get userDesc() {
    if (this.user.planExpiredAt > Date.now()) {
      return this.user.planId === 'GAME' ? i18n.t('dash-user-game') : i18n.t('dash-user-turbo');
    }
    return i18n.t('dash-user-free')
  }

  get plan() {
    return this.user &&
      this.user.planId !== 'FREE' &&
      this.user.planExpiredAt > Date.now()
      ? 'TURBO'
      : 'FREE';
  }

  get userClassname() {
    const className = [];
    if (this.user.planExpiredAt > Date.now()) {
      className.push(this.user.planId === 'GAME' ? 'svip' : 'vip');
    } else {
      className.push('free');
    }
    if (this.isTrial) {
      className.push('TRIAL');
    }
    return className.join(' ');
  }

  get planExpiredAt() {
    return this.user.planExpiredAt;
  }

  get name() {
    return this.user.name;
  }

  get buyTag() {
    return this.user.buyTag;
  }

  get status() {
    return this.user.status;
  }

  get hasPassword() {
    return this.user.hasPassword;
  }

  get hasBindWechat() {
    return this.user.hasBindWechat;
  }

  get displayName() {
    return this.user.displayName;
  }

  get needSetPassword() {
    // for gmail user
    return !this.user.hasPassword && this.user.email !== '';
  }

  get needBindEmail() {
    // for wechat user
    return (
      this.user.email === '' && this.user.wechatName && !this.user.hasPassword
    );
  }

  get wechatName() {
    return this.user.wechatName;
  }

  get token() {
    return this.user.token;
  }

  get planMode() {
    return this.user.planMode;
  }

  get isEdu() {
    return this.user.isEdu;
  }

  get phone() {
    return this.user.phone;
  }

  get isEduEmail() {
    const [, emailDomain] = this.user.email.split('@');
    return emailDomain.indexOf('.edu') >= 0 && this.user.school;
  }

  get isTrial() {
    if (this.user.trialExpiredAt && this.user.trialExpiredAt > Date.now()) {
      return this.user.trialPlanId;
    }
    return false;
  }

  get trialPlanId() {
    return this.user.trialPlanId;
  }

  get trialExpiredAt() {
    return this.user.trialExpiredAt;
  }

  get extraClientsExpiredAt() {
    return this.user.extraClientsExpiredAt;
  }

  get clients() {
    return this.userType !== 'FREE' ? this.user.devices : 1;
  }

  get privcateServer() {
    return this.user.privateServerExpiredAt > Date.now() &&
      this.user.privateServer
      ? this.user.privateServer
      : '';
  }

  get bandwidth() {
    return this.user.bandwidth;
  }

  get gameBandwidth() {
    return this.user.gameBandwidth;
  }

  get gameBandwidthExpiredAt() {
    return this.user.gameBandwidthExpiredAt;
  }

  get bandwidthExpiredAt() {
    return this.user.bandwidthExpiredAt;
  }

  object() {
    return this.user;
  }
}

export default User;
